import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider } from '@chakra-ui/react';
import { Progress } from './components';

interface NewScheduleHeaderProps {
  isMultiple?: boolean;
  step: number;
}

export const NewScheduleHeader = ({
  isMultiple = false,
  step,
}: NewScheduleHeaderProps) => {
  const navigate = useNavigate();

  const handleNavigateNewSchecule = () => {
    navigate('/agendamentos');
  };

  return (
    <Box
      mt="12px"
      px={{ base: '16px', md: '32px' }}
      flex={1}
      minH="full"
      fontSize="xl"
    >
      <Box position="sticky" top="0">
        <Button
          mt="24px"
          aria-label="Voltar para agendamento"
          variant="outline"
          display="flex"
          alignItems="center"
          onClick={handleNavigateNewSchecule}
        >
          Voltar para agendamento
        </Button>

        <Progress step={step} isMultiple={isMultiple} />

        <Divider
          aria-hidden="true"
          borderWidth="1px"
          borderColor="grey.600"
          opacity="0.2"
          orientation="horizontal"
          mt="22px"
        />
      </Box>
    </Box>
  );
};
